import axios from 'axios';
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { Form } from 'reactstrap'
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import AddGalaModal from '../../../components/Modal/AddGalaModal'
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import { Label } from 'reactstrap';
import Table from '../../../components/Table';
import { environment } from '../../../env';
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction, getBuildingAction } from '../../../redux/actions/Index';
import { useMemo } from 'react';
import { useEffect } from 'react';
import PathName from '../../../components/PathName/PathName';
import Excel from '../../../Helper/Excel';
import LoadBox from "../../../components/Loading/LoadBox";

const Gala = () => {
  const [empbuilding, setEmpBuilding] = useState([]);
  const [emptyfil, setEmptyfil] = useState(false);
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [GalaFilters, setGalaFilters] = useState([]);
  const [GalaFil, setGalaFil] = useState([]);
  const [galaarea, setGalaArea] = useState();
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.Reducers?.userdata);
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const galaList = useSelector((state) => state?.ModalReducer?.galaList);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  let projectName = projectList?.filter((data, i) => data.id == userProject)

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  var selectedBuildingId = watch("building");
  var selectedGala = watch("gala_no")

  const getBuildingData = () => {
    try {
      axios.get(`${environment.baseUrl}building/`).then(res => {
        let data = res.data.filter((data, i) => data?.project.id == userProject)
        dispatch(getBuildingAction(data));
        setFilterBuilding(data)
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (filterBuilding == undefined && userProject != undefined) {
      getBuildingData();
    }
  }, [userProject])

  const galaFilterApiCall = () => {
    if (selectedGala || selectedBuildingId) {
      dispatch(loaderAction(true))
      const SearchUrl = `${environment.baseUrl}gala-filter/?gala_no=${selectedGala}&building=${selectedBuildingId}&project=${projectName[0].name}`;
      const result = axios(SearchUrl).then((res) => {
        if (res?.data?.length > 0) {
          setGalaFilters(res.data);
          setEmptyfil(false)
          dispatch(loaderAction(false))
        }
        else {
          setEmptyfil(true)
          dispatch(loaderAction(false))
          console.log("error");
        }
      })
    }
  }

  useMemo(() => {
    galaFilterApiCall();
  }, [selectedBuildingId, selectedGala])

  useMemo(() => {
    if (selectedBuildingId) {
      var galaselected = galaList?.filter((galalist) => galalist.building.building_no == selectedBuildingId);
      if (galaselected?.length == 0) {
        let building = buildingList.filter((data, i) => data.building_no == selectedBuildingId)
        setEmpBuilding(building)
      }
      else {
        let area = 0
        galaselected.map((data, i) => {
          area = Number(area) + Number(data.builtup_area)
        })
        setGalaArea(area)
        setGalaFil(galaselected);
        setGalaFilters(galaselected);
      }
    }
    else {
      setGalaFilters([]);
    }
    if (selectedGala) {
      var galaselected = galaList?.filter((galalist) => galalist.gala_no == selectedGala);
      setGalaFilters(galaselected);
    }
  }, [selectedBuildingId, selectedGala, galaList])

  const columns = [
    {
      name: 'Building No',
      selector: row => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Gala No',
      selector: row => Number(row.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Builtup Area',
      selector: row => (row.builtup_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sold Area',
      selector: row => (row.builtup_area - row.available_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Reamining Area',
      selector: row => (row.available_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Edit',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <AddGalaModal button='edit' title='Edit New Projects' data={row} onEdit={afterEditGala} buildingListProp={filterBuilding} />
        {/* <button onClick={() => deleteGala(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="24" className='icon-color-red' /></button> */}
      </div>,
    }
  ];
  const column = [
    {
      name: 'Building No',
      selector: row => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Gala No',
      selector: row => Number(row.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Builtup Area',
      selector: row => (row.builtup_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sold Area',
      selector: row => (row.builtup_area - row.available_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Reamining Area',
      selector: row => (row.available_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
  ];

  const afterEditGala = () => {
    galaFilterApiCall();
    if (selectedBuildingId) {
      const SearchUrl = `${environment.baseUrl}gala-filter/?gala_no=${''}&building=${selectedBuildingId}&project=${projectName[0].name}`;
      const result = axios(SearchUrl).then((res) => {
        if (res?.data?.length > 0) {
          setGalaFil(res.data)
          setEmptyfil(false)
        }
        else {
          setEmptyfil(true)
        }
      })
    }
  }

  useMemo(() => {
    let buildings = buildingList?.filter((data, i) => data.project.id == userProject)
    let gala = galaList?.filter(data => data.project?.id == userProject)
    setFilterBuilding(buildings)
    setGalaFilters(gala)
  }, [selectedBuildingId])

  useEffect(() => {
  }, [galaList])

  return (
    <>
      <PathName />
      <SuccessPopups />
      <div className="Building-main">
        <Form >
          <div className='my-4 row'>
            {/* <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
              <div className="mt-1  d-flex gap-3">
                <select
                  id="role_type"
                  name="role_type"
                  className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  {...register("project", { required: true, onChange: (e) => { reset({ 'building': '', 'gala_no': '', 'project': e.target.value }) } })}
                >
                  <option value="" >Project Name</option>
                  {projectList?.map((data, i) => {
                    return <option value={data.name} key={i}>{data.name}</option>;
                  })}
                </select>
              </div>
            </div> */}
            <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
              <div className="mt-1  d-flex gap-3">
                <select
                  id="role_type"
                  name="role_type"
                  className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  {...register("building", { required: true, onChange: (e) => { reset({ 'building': e.target.value, 'gala_no': '' }); setGalaFil([]) } })}
                >
                  <option value="" >Building Number</option>
                  {filterBuilding?.sort((a, b) => a?.building_no?.localeCompare(b.building_no))?.map((data, i) => {
                    return (
                      <option value={data.building_no} key={i}>{data.building_no}</option>
                    );
                  })}
                </select>
              </div>
              {selectedBuildingId &&
                <>
                  {
                    GalaFil.length == 0 ?
                      <>
                        <Label className="pt-1 mb-0 text-base-black d-flex align-item-center justify-content-around">
                          <span className='fs-5 title-font-700'>{`Total Area : ${empbuilding[0]?.area_builtup}`}</span>
                          <span className='fs-5 title-font-700'>{`  Remaining Area : ${empbuilding[0]?.area_builtup}`}</span>
                        </Label>
                      </> :
                      <>
                        <Label className="pt-1 mb-0 text-base-black d-flex align-item-center justify-content-between">
                          <span className='fs-5 title-font-700'>{`Total Area : ${GalaFil[0]?.building?.area_builtup}`}</span>
                          <span className='fs-5 title-font-700'>  {`Remaining Area : ${Number(Number(GalaFil[0]?.building?.area_builtup) - Number(galaarea)).toFixed(2)}`}</span>
                          <span className='fs-5 title-font-700'>{`Sold Area : ${GalaFil[0]?.building.sold_area}`}</span>
                        </Label><br />
                        <Label className=" pt-1 mb-0 text-base-black">
                          <span className='fs-5 title-font-700'>{`Unsold Area : ${GalaFil[0]?.building.area_builtup - GalaFil[0]?.building.sold_area}`}</span>
                        </Label>
                      </>
                  }
                </>
              }
              <br />
            </div>
            <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
              <div className="mt-1  d-flex gap-3">
                <select
                  id="role_type"
                  name="role_type"
                  className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  {...register("gala_no", { required: true })}
                >
                  <option value="" >Gala No</option>
                  {GalaFil?.sort((a, b) => (a?.gala_no || 0) - (b?.gala_no || 0))?.map((data, i) => {
                    return (
                      <option value={data.gala_no} key={i}>{data.gala_no}</option>
                    );
                  })}
                </select>
              </div>
              {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
              <br />
            </div>
          </div>
        </Form >
      </div >
      <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
        <div className="">
          <div className='d-flex justify-content-between align-items-center'>
            <h1 className='title-font-bold '>Galas</h1>
            <div className='d-flex mr-2 gap-3'>
              <Excel gala={true} data={GalaFilters?.length > 0 ? GalaFilters : galaList} />
              <AddGalaModal buildingListProp={filterBuilding} />
            </div>
          </div>
          {localStorage.getItem('gala') != null &&
            <div className="bg-white p-5 rounded-5 mb-5">
              <LoadBox />
            </div>}
          {localStorage.getItem('gala') == null && (galaList?.[0] == undefined ? <EmptyTable /> : emptyfil == true ? <EmptyTable /> : <Table columns={user?.role != 'user' ? columns : column} data={GalaFilters?.length > 0 ? GalaFilters : galaList} />)}
        </div>
      </div>
    </>
  )
}

export default Gala